import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'react-bootstrap';

import SendMailModal from './SendMailModal';

export default function Index({
  enterpriseId, slackRedirectUrl, slackEnabled, slackEnabledAt,
}) {
  const [showModal, setShowModal] = useState(false);

  const redirectUrl = 'https://6jbebkb51g.execute-api.us-east-2.amazonaws.com/v1/api/v1/slack/auth'
                      + `?enterprise_id=${enterpriseId}&back_url=${slackRedirectUrl}`;

  const SLACK_URL = 'https://slack.com/oauth/v2/authorize?'
          + 'client_id=183357387571.7976664185024&scope=app_mentions:read,channels:history,'
          + 'chat:write,im:history,channels:read,groups:read,mpim:read,im:read'
          + `&user_scope=&redirect_uri=${encodeURIComponent(redirectUrl)}`;

  const copyStringToClipboard = (str) => {
    navigator.clipboard.writeText(str);

    swal({
      title: '',
      html: true,
      text: 'Slack Setup Link has been copied to the clipboard.',
    });
  };

  const onSetupSlackClick = () => {
    setShowModal(true);
  };

  return (
    <div className="ibox-content mt20">
      <h2 className="block-title">Setup LeggUP AI Coach</h2>
      <Row>
        <Col md={8}>
          {slackEnabled && (
            <p>
              The Slack workspace of this account is connected to LeggUP
              Performance Coach. The team members of this company can access
              personalized coaching through their Slack accounts.
            </p>
          )}
          {!slackEnabled && (
            <p>
              Please send authorization request for LeggUP Performance
              Coach for company’s Slack workspace. Once approved, team members
              will be able to access personalized coaching directly
              through Slack.
            </p>
          )}

        </Col>
        <Col md={4} className="text-right">
          <div>
            <Button
              onClick={() => copyStringToClipboard(SLACK_URL)}
              bsStyle="primary"
            >
              Copy Link
            </Button>
          </div>
          <div className="mt10">
            <Button
              onClick={onSetupSlackClick}
              bsStyle="primary"
            >
              Setup Slack Link
            </Button>
          </div>
        </Col>
      </Row>
      {showModal && <SendMailModal link={SLACK_URL} enterpriseId={enterpriseId} onHide={() => setShowModal(false)} /> }
    </div>
  );
}

Index.propTypes = {
  enterpriseId: PropTypes.number.isRequired,
  slackRedirectUrl: PropTypes.string.isRequired,
  slackEnabled: PropTypes.bool.isRequired,
  slackEnabledAt: PropTypes.string,
};

Index.defaultProps = {
  slackEnabledAt: '',
};
